import React, {
  ReactElement, ReactNode, useState,
} from 'react';
import {
  Button, Col, FormGroup, Label, Row, Text,
} from 'idsk-react-components';
import './pouzitiePredpisItem.scss';
import VybratPredpis from './VybratPredpis';
import PouzitiePredpis from '../../../../../model/PouzitiePredpis';

interface Props {
  setItemList: (data: PouzitiePredpis[]) => void;
  itemId: number;
  children: ReactNode;
  itemList: Array<PouzitiePredpis>;
  clearAllFieldErrorMessages: () => void;
  getFieldErrorMessage: (fieldName: string) => string;
}

const PouzitieVPredpisochItem = ({
  setItemList,
  itemId,
  children,
  itemList = [],
  clearAllFieldErrorMessages,
  getFieldErrorMessage,
}: Props): ReactElement => {
  const [pouzitiePredpis, setPouzitiePredpis] = useState<PouzitiePredpis>(itemList[itemId]);

  const onRemove = (): void => {
    setItemList(itemList.filter((_, index) => index !== itemId));
    if (clearAllFieldErrorMessages) {
      clearAllFieldErrorMessages();
    }
  };

  return (
    <>
      <div className="pouzitie-predpis-item">
        <FormGroup>
          <Row>
            <Col width="two-thirds">
              <Label htmlFor="url">Právny predpis</Label>
              <Text className="pouzitie-predpis-zdroj-hint">Je možné vybrať konkrétny právny predpis.</Text>
            </Col>
          </Row>
          <Row>
            <Col width="two-thirds">
              <VybratPredpis
                pouzitiePredpis={pouzitiePredpis}
                setPouzitiePredpis={setPouzitiePredpis}
                setItemList={setItemList}
                itemId={itemId}
                itemList={itemList}
                error={getFieldErrorMessage(`url${itemId}`)}
              />
            </Col>
          </Row>
        </FormGroup>

        {itemList.length > 0 && (
        <Row>
          <Col width="two-thirds">
            <Button
              type="button"
              size="large"
              className="remove-button"
              buttonStyle="negative"
              onClick={onRemove}
            >
              Zmazať použitie v PP
            </Button>
          </Col>
        </Row>
        )}
      </div>
      {children && pouzitiePredpis.url && pouzitiePredpis.url.trim().length > 0 && <>{children}</>}
    </>
  );
};

export default PouzitieVPredpisochItem;
